import { createContext } from 'react';

import { createStore, type Store } from '../../../core/store/store.js';
import { INITIAL_SANKEY_STATE } from '../constants.js';
import type { SankeyState } from '../types/sankey-state.js';

export const SankeyStoreContext = createContext<Store<SankeyState>>(
  createStore<SankeyState>(INITIAL_SANKEY_STATE),
);

SankeyStoreContext['displayName'] = 'SankeyStoreContext';
